// Funcoes de calculo de ocorrencia de eventos recorrentes -- mesma logica
// usada em Eventos.jsx (copiada aqui, nao importada de la, pra nao arriscar
// mexer num arquivo que ja esta em producao), reaproveitada pela Home pro
// banner de destaque automatico (ver RECURRING_FEATURED_BANNERS em Home.jsx).
// Datas sao sempre date-only em UTC (meia-noite UTC) -- mesma convencao do
// resto do app, ver comentario equivalente em Eventos.jsx sobre por que
// getters UTC (nao locais) sao usados pro corte de "hoje".
const RECURRENCE_MAX_ITERATIONS = 30;

export function utcDateKey(d) {
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
}

export function addUTCDays(d, days) {
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + days));
}

export function generateRecurringOccurrences(event) {
  const interval = event.recurrenceIntervalDays;
  if (!interval || interval < 1) return [];
  const skipKeys = new Set((event.recurrenceSkipDates || []).map((d) => utcDateKey(new Date(d))));
  const occurrences = [];
  let cursor = new Date(event.date);
  for (let i = 0; i < RECURRENCE_MAX_ITERATIONS; i += 1) {
    const key = utcDateKey(cursor);
    if (!skipKeys.has(key)) occurrences.push(new Date(cursor));
    cursor = addUTCDays(cursor, interval);
  }
  return occurrences;
}

// Proxima ocorrencia (recorrente ou nao) que caia em todayFloor ou depois.
// todayFloor precisa ser meia-noite UTC (Date.UTC(ano, mes, dia)) pro corte
// de "hoje" bater com as datas date-only vindas do banco.
export function nextOccurrenceOnOrAfter(event, todayFloor) {
  const eventDate = new Date(event.date);
  if (!event.recurrenceIntervalDays) {
    return eventDate >= todayFloor ? eventDate : null;
  }
  const occurrences = generateRecurringOccurrences(event).filter((d) => d >= todayFloor);
  return occurrences.length > 0 ? occurrences[0] : null;
}
